import React from 'react';
import { Container } from '@groupelacentrale/contact-storybook';
import { CollapsibleContainer } from './CollapsibleContainer';
import './StyledContainer.scss';

interface Props {
  title: React.ReactNode;
  open: boolean;
  id: string;
  onOpen: (id?: string) => undefined | void;
  onClose: () => undefined | void;
  children: React.ReactNode;
}

const Styled: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (
  { title, open, id, onOpen, onClose, children },
  ref?,
) => {
  return (
    <Container shadowed paddings="noP" backgroundColor="bgWhite" className={open ? 'expanded' : undefined}>
      <CollapsibleContainer ref={ref} title={title} open={open} id={id} onOpen={onOpen} onClose={onClose}>
        {children}
      </CollapsibleContainer>
    </Container>
  );
};

export const StyledContainer = React.forwardRef(Styled);
